<script>
	import Clock from "./Clock.svelte";
	import Explanation from "./Explanation.svelte";
	import MainText from "./MainText.svelte";
	import Info from "./Info.svelte";
	import Header from "./Header.svelte";
</script>

<main>
	<Header />
	<div class="tttbg">
		<Explanation />
		<Clock />
	</div>
	<MainText />
	<Info />
</main>

<style>
	@import url("https://fonts.googleapis.com/css2?family=Annie+Use+Your+Telescope&family=Raleway&family=Syne+Mono&family=IM+Fell+English+SC&display=swap");
	main {
		padding: 1em;
		max-width: 700px;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		flex-direction: column;
	}

	div.tttbg {
		max-width: 700px;
		display: grid;
		grid-template-columns: 1fr 1fr;
	}

	@media (orientation: portrait) {
		main {
			flex-direction: left;
		}
		div.tttbg {
			grid-template-columns: 1fr;
		}
	}
</style>
